import firebase from 'firebase8';

let _database = null;
let _storage = null;
let _auth = null;

export const messaging = () => {
  return {
    messaging: () => {},
    subscribeToTopic: () => {},
  };
};

export const initFirebase = () => {
  console.log('starting firebase');
  if (!global?.appStarted) {
    console.log('firbase init');

    const config = {
      apiKey: 'AIzaSyCMRIDyzb0VRjWTjCu8CZtnzGkLMbjIMt8',
      authDomain: 'barhuntv2.firebaseapp.com',
      databaseURL: 'https://barhuntv2.firebaseio.com',
      projectId: 'barhuntv2',
      storageBucket: 'barhuntv2.appspot.com',
      messagingSenderId: '472107255951',
    };

    // Firebase.database.enableLogging(true);
    if (!firebase.apps?.length) {
      firebase.initializeApp(config);
    }
    global?.appStarted == true;
  }
};

export const getDatabase = () => {
  if (!_database) {
    initFirebase();
    _database = firebase.database();
  }
  return _database;
};

export const getStorage = () => {
  if (!_storage) {
    initFirebase();
    _storage = firebase.storage();
  }
  return _storage;
};

export const getAuth = () => {
  if (!_auth) {
    _auth = firebase.auth();
  }
  return _auth;
};

export const crashlytics = () => {
  return {};
};

export const analytics = () => {
  return {};
};
